import { SignalDispatcher } from 'ste-signals';

export const userEvents = {
  newUserCreated: new SignalDispatcher(),
  userUpdated: new SignalDispatcher(),
  currentUserUpdated: new SignalDispatcher(),
};
